import { getContext } from '@fiverr-private/fiverr_context';

const getCommonFields = (eventName: string) => {
    const { userId, userGuid, pageCtxId, isTouch } = getContext();

    return {
        type: eventName,
        user: { id: userId },
        buyer: { id: userId },
        uid: userGuid,
        page: { ctx_id: pageCtxId },
        platform: isTouch ? 'mobile_web' : 'web',
    };
};

export const getBaseImpressionEvent = (eventName: string) => ({
    ...getCommonFields(eventName),
    group: 'user_impression',
    action: { type: 'impression' },
});
